import { ApiClientError } from '@/api/apiClient';

export function getErrorMessage(error: Error | null, fallback: string): string {
  if (!error) return fallback;
  if (error instanceof ApiClientError) {
    const reason = error.reason as unknown;
    if (typeof reason === 'string') return reason;
    if (Array.isArray(reason)) return reason.join(', ');
    if (reason && typeof reason === 'object' && 'messages' in reason) {
      const messages = (reason as { messages: string[] }).messages;
      if (Array.isArray(messages)) return messages.map(m => m.replace(/^\w+:\s*/, '')).join(', ');
    }
  }
  if (error.message && error.message !== '[object Object]') return error.message;
  return fallback;
}
